import { render } from "./DiscountCalculator.vue?vue&type=template&id=95c8c6b6"
import script from "./DiscountCalculator.vue?vue&type=script&lang=js"
export * from "./DiscountCalculator.vue?vue&type=script&lang=js"

import "./DiscountCalculator.vue?vue&type=style&index=0&id=95c8c6b6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__